module.exports = __webpack_public_path__ + "img/bx-play.a6150445.svg";